module.exports = __webpack_public_path__ + "img/IMG_8989.e1293a2b.jpg";